import styled from "styled-components";
import { colors, spacingExtender } from "ui-components";

const RiskListHeader = styled.div`
  color: ${colors.darkBlue};
  font-weight: bold;
  font-size: 12px;
  ${() => spacingExtender({ paddingT: "2", paddingH: "4" })};
`;

const RiskSelectorWrapper = styled.li`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-size: 12px;
  border-bottom: 1px solid ${colors.lightGrey};
  ${() => spacingExtender({ paddingH: "4", paddingV: "2" })};
`;

const RiskSelectorContent = styled.div`
  display: flex;
  position: relative;
`;

const RiskSelectorIcon = styled.img`
  /* Only display is the risk is elevated and selected */
  display: ${({ isShown }) => (isShown ? "block" : "none")};
  position: absolute;
  top: 3px;
  left: -5px;
  cursor: pointer;
`;

const RiskSelectorText = styled.span`
  display: flex;
  flex-grow: 1;
  margin-left: 15px;
  /* Vertically center text but keep the bullet at the text baseline */
  align-self: center;
  align-items: baseline;

  /* Add a bullet to the text */
  &:before {
    display: block;
    position: absolute;
    /* Hide the bullet for elevated risks that have been indicated (custom icon) */
    content: ${({ isBulletShown }) => (!isBulletShown ? '"\\2022"' : '""')};
    /* Absolute position and negative margin allow knowing exactly where text is (used for header) */
    margin-left: -15px;*/
  }
`;

const RiskSelectorButtons = styled.div`
  display: flex;
  flex-shrink: 0; /* IE 11 fix */
  align-items: center;
  margin-left: 20px;
  cursor: pointer;

  label {
    margin-bottom: 0;
    font-family: ${({ theme }) => theme.fonts.family.bookText};
    font-weight: ${({ theme }) => theme.fonts.weight.bookText};
  }
`;

// Special fix for MUI Toggle (pretravel/previsit) to make the additional label seem part of the Toggle
const RiskSelectorToggleLabel = styled.label`
  margin-right: 8px;
  line-height: 24px;
`;

const RiskSelectorInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin-top: 1rem;
  margin-left: auto;
  text-align: right;
`;

const RiskSelectorLink = styled.div`
  color: ${colors.maroon};
  font-weight: 500;
`;

export {
  RiskListHeader,
  RiskSelectorWrapper,
  RiskSelectorContent,
  RiskSelectorIcon,
  RiskSelectorText,
  RiskSelectorInfo,
  RiskSelectorButtons,
  RiskSelectorToggleLabel,
  RiskSelectorLink
};



// WEBPACK FOOTER //
// ./src/common/styled/risk.js